/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type {
  RegisterExternalPatientBodyOne,
  RegisterExternalPatientBodyThree,
  RegisterExternalPatientBodyTwo,
  RegisterExternalPatientErrorResponse,
  RegisterSuccessResponse,
} from './api.schemas';

import { api } from '../util/http';

export const registerExternalPatient = (
  registerExternalPatientBody:
    | RegisterExternalPatientBodyOne
    | RegisterExternalPatientBodyTwo
    | RegisterExternalPatientBodyThree,
  signal?: AbortSignal,
) => {
  return api<RegisterSuccessResponse>({
    url: `/api/auth/register-external-patient`,
    method: 'POST',
    data: registerExternalPatientBody,
    signal,
  });
};

export const getRegisterExternalPatientMutationOptions = <
  TError = RegisterExternalPatientErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerExternalPatient>>,
    TError,
    {
      data:
        | RegisterExternalPatientBodyOne
        | RegisterExternalPatientBodyTwo
        | RegisterExternalPatientBodyThree;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof registerExternalPatient>>,
  TError,
  {
    data:
      | RegisterExternalPatientBodyOne
      | RegisterExternalPatientBodyTwo
      | RegisterExternalPatientBodyThree;
  },
  TContext
> => {
  const mutationKey = ['registerExternalPatient'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof registerExternalPatient>>,
    {
      data:
        | RegisterExternalPatientBodyOne
        | RegisterExternalPatientBodyTwo
        | RegisterExternalPatientBodyThree;
    }
  > = (props) => {
    const { data } = props ?? {};

    return registerExternalPatient(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegisterExternalPatientMutationResult = NonNullable<
  Awaited<ReturnType<typeof registerExternalPatient>>
>;
export type RegisterExternalPatientMutationBody =
  | RegisterExternalPatientBodyOne
  | RegisterExternalPatientBodyTwo
  | RegisterExternalPatientBodyThree;
export type RegisterExternalPatientMutationError = RegisterExternalPatientErrorResponse;

export const useRegisterExternalPatient = <
  TError = RegisterExternalPatientErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof registerExternalPatient>>,
      TError,
      {
        data:
          | RegisterExternalPatientBodyOne
          | RegisterExternalPatientBodyTwo
          | RegisterExternalPatientBodyThree;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof registerExternalPatient>>,
  TError,
  {
    data:
      | RegisterExternalPatientBodyOne
      | RegisterExternalPatientBodyTwo
      | RegisterExternalPatientBodyThree;
  },
  TContext
> => {
  const mutationOptions = getRegisterExternalPatientMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
